// extracted by mini-css-extract-plugin
export default {"main_image_detail":"ImageOnGrid_main_image_detail__nSZAE","dionisiache":"ImageOnGrid_dionisiache__i198y","image_detail":"ImageOnGrid_image_detail__MKjqR"};